<template>
  <div>
     <div class="search-mask" v-if="showSearchPanel" @click="close"></div>
    <div class="search-panel" v-if="showSearchPanel" @click.stop>
      <div class="search-panel-header">
        <div class="search-input-wrapper">
          <input
            type="text"
            v-model="localKeyword"
            @input="handleSearchInput"
            :placeholder="searchPlaceholder"
            class="search-input"
            ref="searchInputDom"
          />
          <button class="search-close" @click="close">✕</button>
        </div>
      </div>
      <div class="search-results">
        <div 
          class="search-result-item"
          v-for="(result, index) in searchResults"
          :key="`${result.id}-${index}`"
          :class="{ active: index === currentResultIndex }"
          @click="scrollToResult(index)"
        >
          <div class="result-path" v-html="highlightKeyword(result.fullPath)"></div>
          <div class="result-content" v-html="highlightKeyword(result.content)"></div>
        </div>
        <div class="no-results" v-if="searchResults.length === 0 && localKeyword.trim()">
          {{ noSearchResultText }}
        </div>
        <div class="no-results" v-if="!localKeyword.trim()">
          {{ inputSearchKeywordText }}
        </div>
      </div>
      <div class="search-panel-footer">
        <span>{{ searchResults.length }} {{ resultCountText }}</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'SdkDocumentSearch',
  props:{
      showSearchPanel: {
      type: Boolean,
      default: false
    },
    searchKeyword: {
      type: String,
      default: ''
    },
    searchPlaceholder: {
      type: String,
      default: ''
    },
    searchResults: {
      type: Array,
      default: []
    },
    inputSearchKeywordText:{
      type: String,
      default: ''
    },
    resultCountText:{
      type: String,
      default: ''
    },
    noSearchResultText:{
       type: String,
      default: ''
    },
    currentResultIndex:{
      type:Number,
      default:-1
    },
    highlightKeyword: {
      type: Function,
      required: true
    },
    scrollToResult: {
      type: Function,
      required: true
    }
  },
  watch: {
    searchKeyword(newVal) {
      this.localKeyword = newVal;
    },
    showSearchPanel(newVal) {
      if (newVal) {
        // 面板显示时，延迟获取焦点（确保DOM已渲染）
        this.$nextTick(() => {
          const inputEl = this.$refs.searchInputDom;
          if (inputEl) {
            inputEl.focus();
            // 可选：自动选中输入框内的现有文本
            inputEl.select();
          }
        });
      }
    }
  },
  data() {
    return {
       localKeyword: this.searchKeyword
    };
  },

  mounted() {
    if (this.showSearchPanel) {
      this.$nextTick(() => {
        const inputEl = this.$refs.searchInputDom;
        inputEl && inputEl.focus();
      });
    }
  },

  methods: {
    handleSearchInput(){
      this.$emit('SearchInput',this.localKeyword)
    },
    close(){
      this.localKeyword = '';
      this.$emit('SearchClose');
      // 失去焦点（可选）
      const inputEl = this.$refs.searchInputDom;
      inputEl && inputEl.blur();
    }
  },
};
</script>